export default __webpack_public_path__ + "static/media/logo-light.e804529a.png";